<!--component html goes here -->

<header [ngClass]="{ business: corpPartner.updateBgColor || businessUser }">
  <ngc-switching-account
    *ngIf="isloggedIn && contentInterstitialBanner"
    [bannerDetails]="contentInterstitialBanner"
    [isDesktop]="deviceTypes.isDesktop"
  ></ngc-switching-account>
  <nav class="shop-header-view bg-dark navbar fixed-top">
    <div
      *ngIf="isDarkSiteEnabled && !isLightHeaderFooterEnable"
      class="container"
    >
      <div class="d-flex flex-row shop-header-content" id="main_nav">
        <div class="delta-header align-middle">
          <!-- <a class="delta-logo-header d-none d-lg-block d-xl-block " href="{{slimheaderLogoUrl}}">
                        <img src="{{slimheaderLogo}}"  alt="{{slimheaderLogoAltText}}" style="width: 1.5625rem;"/>
                    </a>       -->

          <a
            #toggle
            (click)="navigationDrawer()"
            [attr.aria-expanded]="navigation ? 'false' : 'true'"
            [attr.aria-label]="
              navigation ? 'Navigation menu' : 'Close navigation menu'
            "
            [ngClass]="{ active: !navigation }"
            att.aria-controls="headerLinksContainer"
            class="hamburger-icon d-lg-none"
            href="javascript:void(0)"
            id="hamburger-icon"
            title="Menu"
          >
            <span class="line line-1"></span>
            <span class="line line-2"></span>
            <span class="line line-3"></span>
            <span aria-hidden="true" class="sr-only">Navigation menu</span>
          </a>
          <ngc-logo
            [corpPartner]="corpPartner"
            [displayBusinessTypeSection]="displayBusinessTypeSection"
            [mobileDarkSiteLogo]="isDarkSiteEnabled"
            class="d-none d-lg-block"
          ></ngc-logo>
        </div>

        <div
          class="separator d-none d-lg-inline-block text-center align-middle"
        >
          <span>|</span>
        </div>

        <div class="origin-dest-header market-header align-middle">
          <a
            (click)="toggleContent($event); scrollTop()"
            (keydown)="handleFocusEvent($event)"
            aria-controls="booking"
            aria-expanded="false"
            class="modify-link"
            href="javascript:void(0);"
          >
            <span class="d-none d-md-inline-block market-header">
              {{ fromCity }} - {{ toCity }}
            </span>
          </a>
        </div>

        <div
          class="separator d-none d-lg-inline-block text-center align-middle"
        >
          <span>|</span>
        </div>

        <div class="triptype-header d-none d-lg-inline-block align-middle">
          <a
            (click)="toggleContent($event); scrollTop()"
            (keydown)="handleFocusEvent($event)"
            aria-controls="booking"
            aria-expanded="false"
            class="modify-link"
            href="javascript:void(0);"
          >
            <span>{{ tripType }}</span>
          </a>
        </div>

        <div
          class="separator d-none d-lg-inline-block text-center align-middle"
        >
          <span>|</span>
        </div>

        <div class="tripdate-header align-middle">
          <a
            (click)="toggleContent($event); scrollTop()"
            (keydown)="handleFocusEvent($event)"
            aria-controls="booking"
            aria-expanded="false"
            class="modify-link"
            href="javascript:void(0);"
          >
            <span *ngIf="!returnDate || returnDate === ''">
              {{ departDate | date : 'MMM d' }}
            </span>
            <span
              *ngIf="
                returnDate &&
                returnDate !== '' &&
                (departDate | date : 'MMM') !== (returnDate | date : 'MMM')
              "
            >
              {{ departDate | date : 'MMM d' }}-{{
                returnDate | date : 'MMM d'
              }}
            </span>
            <span
              *ngIf="
                returnDate &&
                returnDate !== '' &&
                (departDate | date : 'MMM') === (returnDate | date : 'MMM')
              "
            >
              {{ departDate | date : 'MMM d' }}-{{ returnDate | date : 'd' }}
            </span>
          </a>
        </div>

        <div class="separator text-center d-none d-md-block align-middle">
          <span>|</span>
        </div>

        <div
          *ngIf="corpPartner.restrictPaxToOne || restrictNewPaxToOne"
          class="paxcount-header d-none d-lg-inline-block align-middle"
        >
          <a
            (click)="toggleContent($event); scrollTop()"
            (keydown)="handleFocusEvent($event)"
            aria-controls="booking"
            aria-expanded="false"
            class="modify-link"
            href="javascript:void(0);"
          >
            <span>1 Passenger</span>
          </a>
        </div>

        <div
          *ngIf="!corpPartner.restrictPaxToOne || !restrictNewPaxToOne"
          class="paxcount-header d-none d-lg-inline-block align-middle"
        >
          <a
            (click)="toggleContent($event); scrollTop()"
            (keydown)="handleFocusEvent($event)"
            aria-controls="booking"
            aria-expanded="false"
            class="modify-link"
            href="javascript:void(0);"
          >
            <span>{{ paxcount }}</span>
          </a>
        </div>

        <div
          class="separator d-none d-lg-inline-block text-center align-middle"
        >
          <span>|</span>
        </div>

        <div class="modify-header align-middle">
          <a
            (click)="toggleContent($event); scrollTop()"
            (keydown)="handleFocusEvent($event)"
            aria-controls="booking"
            aria-expanded="false"
            class="modify-link modify-btn-border"
            href="javascript:void(0);"
          >
            <span class="modify-text">{{ editSearchLabel }}</span>
            <span
              [ngClass]="
                !showFlag
                  ? 'icon-AdvSearchTriangle-up toggle-up'
                  : 'icon-advsearchtriangle'
              "
              class="open-flyout"
            ></span>
          </a>
        </div>
        <div class="login-header">
          <ngc-login
            #loggedinComponent
            (crpNamesInfo)="getCrpNames($event)"
            (custId)="getCustId($event)"
            (edpFlag)="getEdpFlag($event)"
            (isLoggedinFlag)="getLoggedIn($event)"
            (prefCity)="getPrefCity($event)"
            *ngIf="toggle?.offsetParent !== null"
            [corpPartner]="corpPartner"
            [displayBusinessTypeSection]="displayBusinessTypeSection"
            [isAlertAdvisory]="isAlertAdvisory"
            [ngClass]="{ 'd-block': navigation, 'd-none': !navigation }"
            class="d-none d-lg-none"
          ></ngc-login>
        </div>
        <div
          [ngClass]="{
            'd-none': navigation,
            'd-inline-block align-middle': !navigation
          }"
          class="flight-search-mobile search-icon"
        >
          <ngc-search class="d-lg-none float-right search-ham"></ngc-search>
        </div>
        <div
          [@navigation]="navigation"
          [style.top.px]="widgetContainerTop"
          class="bg-dark navbar-collapse main-container"
          id="headerLinksContainer"
          style="display: none !important; margin-left: 0"
        >
          <ngc-app-navigation-links
            (navItemClicked)="toggleContent($event)"
            [inMobile]="toggle?.offsetParent !== null"
            [isMobileDevice]="isMobileDevice"
            [isNotHome]="isNotHome"
            [isSlimHeader]="isSlimHeader"
            [isWarmState]="isWarmState"
            [isloggedIn]="isloggedIn"
            [newNavItem]="selectedNavItem"
          ></ngc-app-navigation-links>
          <div class="mobile-container row align-items-center">
            <span
              *ngIf="toggle?.offsetParent !== null"
              [ngClass]="{ 'text-center': !isHamberger }"
              class="contact-us-container col-12 col-md-2"
            >
              <a
                [attr.href]="contentContactUs?.contactUsUrl"
                id="contact-us-link"
              >
                {{ contentContactUs?.contactUsLabel }}
              </a>
            </span>
            <ngc-language-selector
              *ngIf="toggle?.offsetParent !== null && !disableCLS"
              class="col-12 col-md-9 lang-selector-hamburger"
              isHamberger="true"
            ></ngc-language-selector>
          </div>
          <div *ngIf="isloggedIn" class="d-lg-none logout-section">
            <a
              (click)="logOut()"
              class="col logout-btn"
              href="javascript:void(0);"
              role="button"
            >
              {{ contentMyFlightPanel?.logoutLabel }}
            </a>
          </div>
        </div>

        <div
          [ngClass]="{ 'd-none': !navigation, 'd-flex': navigation }"
          class="d-flex right-rail-container flex-row"
        >
          <ng-container *ngFor="let item of auxiliaryArr">
            <ng-container [ngSwitch]="item.id">
              <ngc-notification
                (modalServiceRef)="saveModalServiceRef($event)"
                *ngSwitchCase="'notification'"
                [isAlertAdvisory]="isAlertAdvisory"
                [isloggedIn]="isloggedIn"
                [ngClass]="{ 'd-block': navigation }"
                class="d-none d-md-inline-block"
              ></ngc-notification>
              <ngc-search
                (modalServiceRef)="saveModalServiceRef($event)"
                *ngSwitchCase="'searchfeed'"
                [isAlertAdvisory]="isAlertAdvisory"
                class="d-none d-lg-inline-block"
              ></ngc-search>
              <ng-container *ngSwitchCase="'login'">
                <ngc-login
                  #loggedinComponent
                  (crpNamesInfo)="getCrpNames($event)"
                  (custId)="getCustId($event)"
                  (disableBusinessPicker)="disableBusinessPage($event)"
                  (edpFlag)="getEdpFlag($event)"
                  (isLoggedinFlag)="getLoggedIn($event)"
                  (modalServiceRef)="saveModalServiceRef($event)"
                  (prefCity)="getPrefCity($event)"
                  *ngIf="toggle?.offsetParent === null"
                  [corpPartner]="corpPartner"
                  [displayBusinessTypeSection]="displayBusinessTypeSection"
                  [isAlertAdvisory]="isAlertAdvisory"
                ></ngc-login>
              </ng-container>
              <ng-container *ngSwitchCase="'profileSelector'">
                <!--*ngSwitchCase="'businessType'"-->
                <ng-container
                  *ngIf="
                    (isloggedIn || isWarmState) &&
                    displayBusinessTypeSection &&
                    !restrictProfileSelector &&
                    isReady
                  "
                >
                  <ngc-business-user
                    [alreadyLogged]="isloggedIn"
                    [crpInfo]="crpInfo"
                    [hasBusinessOnly]="hasCorpCookie"
                    [isWarmState]="isWarmState"
                  ></ngc-business-user>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- Darksite logo is not needed for LightHeaderFooterEnable  -->
    <div
      *ngIf="!isDarkSiteEnabled && !isLightHeaderFooterEnable"
      class="container"
    >
      <ngc-logo
        [corpPartner]="corpPartner"
        [displayBusinessTypeSection]="displayBusinessTypeSection"
        [isLightHeaderFooterEnable]="isLightHeaderFooterEnable"
        [mobileDarkSiteLogo]="isDarkSiteEnabled"
      ></ngc-logo>
      <div class="superGraphicLogoDarksite"></div>
    </div>
    <div *ngIf="isLightHeaderFooterEnable" class="container">
      <ngc-logo
        [corpPartner]="corpPartner"
        [displayBusinessTypeSection]="displayBusinessTypeSection"
        [isLightHeaderFooterEnable]="isLightHeaderFooterEnable"
        [mobileDarkSiteLogo]="isDarkSiteEnabled"
        [ngClass]="{ 'm-auto': isLightHeaderFooterEnable === true }"
      ></ngc-logo>
    </div>
  </nav>

  <div
    #container
    *ngIf="!showFlag"
    [ngClass]="{ 'mobile-widget-container': isMobile }"
    class="shop-header-widget widget-container-lg nav-content-outlet bg-dark main-container collapse-widget floating-header"
  >
    <ngc-book
      (xButtonClicked)="closeModifyButton()"
      [businessAccountOptionsList]="businessAccountOptionsList"
      [canBookNonRefundable]="canBookNonRefundable"
      [corpPartner]="corpPartner"
      [custId]="userId"
      [fromShopHeader]="true"
      [isWidgetAlwaysExpanded]="true"
      [sendRecentSearch]="recentSearchSelected"
      [triggerDefaultLookupEvent]="triggerDefault"
      [isShoppingAwsFlow]="isShoppingAwsFlow"
      [isloggedIn]="isloggedIn"
      [nextgenPage]="nextgenPage"
      [isModifiedFromNavBar]="isModifyClicked"
    ></ngc-book>
  </div>
  <ngc-unsupported-browser
    #browserCompatability
    [unsupportedbrowser]="unSupportedBrowser"
  ></ngc-unsupported-browser>
</header>
